<template>
  <v-layout row wrap>
    <v-dialog v-model="pdfWindow" :persistent="loading == false ? false : true" :overlay="false" max-width="500px"
      transition="dialog-transition">
      <v-card>
        <v-toolbar color="white" class="elevation-1" card>
          <v-toolbar-title class="black--text font-weight-light">
            {{pdfWindowTitle}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="error" title="Cancelar" icon round flat
              @click.stop.prevent="pdfWindow = false, editingPdf = false">
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field box v-model="pdfModel.name" label="Nome"></v-text-field>
          <v-layout row justify-center pa-3>
            <v-chip class="white--text font-weight-light" color="info" v-if="pdfModel.file && pdfName">{{pdfModel.file
              ? pdfName : pdfModel.file ? pdfModel.file :'Sem documentos'}}</v-chip>
          </v-layout>
          <v-layout row justify-center>
            <v-tooltip bottom style="width:100%">
              <v-btn slot="activator" class="white--text font-weight-light headline" label=" Enviar seus documentos"
                color="primary" round block outline @click="pickPdf">
                <v-icon>attach_file</v-icon>
              </v-btn>
              <span class="font-weight-light">Enviar arquivo (PDF)</span>
            </v-tooltip>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" round block @click.native.prevent="savePdf(pdfModel)">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Documentos -->
    <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
      <v-footer class="pa-3 elevation-1" style="border-radius: 5px;" height="auto" width="100%" color="info"
        v-if="!disableActions">
        <span class="white--text">
          <strong>AVISO:</strong>
          Todos arquivos enviados devem conter o formato '.pdf', caso contrário os arquivos não serão
          aceitos!
        </span>
      </v-footer>
      <v-layout row justify-center class="px-3 pt-3" v-if="!disableActions">
        <v-tooltip bottom style="width:100%">
          <v-btn slot="activator" class="white--text font-weight-light headline" label=" Enviar seus documentos"
            color="primary" round block large outline @click="pickPdf">
            E<a class="text-lowercase">nviar</a>
            <v-icon right>attach_file</v-icon>
          </v-btn>
          <span class="font-weight-light">Enviar arquivos (PDF)</span>
        </v-tooltip>
      </v-layout>
      <v-layout row justify-center>
        <v-flex xs12>
          <v-chip class="white--text font-weight-light" color="info" v-if="pdfName">
            {{pdfName ? pdfName : 'Sem documentos selecionados'}}</v-chip>
        </v-flex>
        <v-spacer></v-spacer>
      </v-layout>
      <input type="file" style="display: none" ref="pdf" accept="application/pdf" @change="onPdfPicked">
      <v-layout row wrap v-if="contractDocuments">
        <v-container fluid grid-list-md>
          <v-data-iterator v-if="contractDocuments.length > 0" :items="contractDocuments" content-tag="v-layout" row
            wrap hide-actions no-data-text="">
            <v-flex slot="item" slot-scope="props" class="px-0" xs12>
              <v-card>
                <v-toolbar color="primary" card>
                  <v-toolbar-title class="white--text font-weight-light">{{props.item.name}}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn v-if="props.item.name.slice(-3) == 'pdf'" color="red accent-2" disabled small round icon>
                      <v-avatar size="30" class="font-weight-light white--text" color="red accent-2">
                        {{props.item.name.slice(-3)}}
                      </v-avatar>
                    </v-btn>
                    <v-btn color="white" icon flat title="Abrir Documento" round @click="openPdf(props.item.file)">
                      <v-icon>call_made</v-icon>
                    </v-btn>
                    <v-btn color="teal lighten-2" icon flat round title="Editar Envio" :disabled="disableActions"
                      @click="editPdf(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn color="error" icon flat title="Remover Anexo" :disabled="disableActions" round
                      @click="openDialogToRemove(props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
              </v-card>
            </v-flex>
          </v-data-iterator>
          <alert-delete ref="dialogToDeleteDocument" @deleteItem="removePdf"></alert-delete>
        </v-container>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import AlertDelete from './../../AlertDelete';
  export default {
    props: {
      contractDocuments: {
        type: Array,
        default: []
      },
      disableActions: {
        type: Boolean,
        default: false
      }
    },
    components: {
      AlertDelete,
    },
    data() {
      return {
        //PDFs
        pdfName: "",
        pdfUrl: "",
        pdfWindow: false,
        pdfWindowTitle: "Editar Arquivo",
        pdfModel: {},
        editingPdf: false,
        savingcontract: false,
        //contractDocuments: [],
        loading: false,
        disabledButtonSave: true,
      }
    }, //data()

    methods: {
      initialize() {
        this.pdfName = "";
        this.pdfUrl = "";
        this.pdfWindow = false;
        this.pdfWindowTitle = "Editar Arquivo";
        this.pdfModel = {};
        this.editingPdf = false;
        this.savingcontract = false
      },
      //pdfs etc
      savePdf(pdf) {
        this.pdfWindow = false;
        let filter = this.contractDocuments.filter(
          document => document._id === pdf._id
        );
        let index = this.contractDocuments.indexOf(filter[0]);
        if (index != -1) {
          this.contractDocuments.splice(index, 1, pdf);
          if (this.pdfModel) {
            this.pdfModel = Object.assign({});
            this.editingPdf = false;
          }
        }
      },

      editPdf(pdf) {
        this.pdfModel = pdf;
        this.pdfWindow = true;
        this.editingPdf = true;
      },
      openDialogToRemove(doc) {
        this.$refs.dialogToDeleteDocument.openDialog(doc);
      },
      removePdf(pdf) {
        let index = this.contractDocuments.indexOf(pdf); //indexOf, não findIndex lmao
        if (index != -1) {
          //Confirmar
          this.contractDocuments.splice(index, 1); //Remover o index achado pelo indexOf
        }
      },

      pickPdf() {
        this.$refs.pdf.click(); //Simular um click no elemento que tem como ref "pdf"
      },

      saveAllDocuments() {
        return this.contractDocuments
      },



      setDocuments(documentsPdf) {
        if (documentsPdf.length > 0) {
          this.contractDocuments = documentsPdf;
        } else this.contractDocuments = [];
      },

      onPdfPicked(e) {
        if (e && e.target.files) {
          //Caso tenha enviado arquivos
          var pdfs = e.target.files; //Pegar os arquivos enviados
        } else {
          return; //Else retornar e não deixar a função continuar
        }
        if (pdfs[0] != undefined && pdfs.hasOwnProperty(0)) {
          //Se o pdf realmente tem o item 0 , melhor se previnir do que se desculpar
          this.pdfName = pdfs[0].name; //Colocar o pdfName com o nome do arquivo
          if (this.pdfName.lastIndexOf(".") <= 0) {
            //Se o arquivo não tiver um tipo
            return;
          }
          let fileReader = new FileReader(); //Ler arquivo
          if (!pdfs.hasOwnProperty(0)) return;
          fileReader.readAsDataURL(pdfs[0]); //Transformar em base64
          fileReader.addEventListener("load", () => {
            //Callback para quando terminar de dar o upload
            this.pdfUrl = fileReader.result; //Pegar o resultado do callback
            if (this.contract != {} && this.editingPdf == false) {
              this.contractDocuments.push({
                //Inserir os documentos no registro caso não esteja em modo de edição
                name: this.pdfName,
                file: this.pdfUrl
              });
            } else if (this.editingPdf == true) {
              //Caso em modo de edição
              this.pdfModel.file = this.pdfUrl; //Deixar o pdf a ser editado com o arquivo que levou upload
            }
          });
        } else {
          this.pdfName = ""; //Else deixar tudo vazio
          this.pdfUrl = "";
        }
      },

      async openPdf(pdf) {
        if (pdf && pdf != undefined && pdf != null && pdf != "") {
          //Fon
          var pdfWindow = window.open(""); //Cria a janela
          await pdfWindow.document.write(
            `<iframe width='100%' height='100%' src='${encodeURI(pdf)}'></iframe>`
          ); //Abrir ela com o pdf
          pdfWindow.focus;
        }
      },

    }
  }

</script>



// WEBPACK FOOTER //
// src/components/contract/Uploads/UploadPdf.vue